<nav class="navbar is-primary">
  <div class="container">
    <div class="navbar-brand">
      <a href="/" class="navbar-item">
        NewGuid.Me
      </a>
      <a role="button" class="navbar-burger burger" aria-label="menu" aria-expanded="false" data-target="navMenu">
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>

  </div>
</nav>


<div class="container">
  <router-outlet></router-outlet>
</div>

<div class="content is-small has-text-right" style="padding:10px;">
  <p>Copyright (c) 2020 - Erico Freitas</p>
</div>